// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"i_Q3-usOq37IXHhReLJWB","cancelBtn":"u1-w03cLavsTovLE7cwfH","saveBtn":"_2zOccjglq_-1BBPfZfGOvN"};